// extracted by mini-css-extract-plugin
export default {"tabItemList":"TabItemList_tabItemList__732oo","tabItem":"TabItemList_tabItem__TPxhc"};